import { EntityAudit } from "@modernary/mui/components/audit";
import { EntityDocuments } from "@modernary/mui/components/document";
import { RouterView, type RouterOptions } from "vue-router";

// Troubleshoot your routes using this - https://paths.esm.dev

const names = {
  asbestosProjects: "AsbestosProject.AsbestosProjects",
  list: "AsbestosProject.AsbestosProjectList",
  // new: "AsbestosProject.AsbestosProjectNew",
  base: "AsbestosProject.AsbestosProjectBase",
  view: "AsbestosProject.AsbestosProjectView",
  // edit: "AsbestosProject.AsbestosProjectEdit",
  asbestosInspectionsChildList: "AsbestosProject.AsbestosInspectionsChildList",
  asbestosNotificationsChildList: "AsbestosProject.AsbestosNotificationsChildList",
  audit: "AsbestosProject.AsbestosProjectAudit",
};

export { names as asbestosProjectRouteNames };

const asbestosProjectRoutes: RouterOptions["routes"] = [
  {
    path: "/asbestosProject",
    name: names.asbestosProjects,
    component: {
      render: () => <RouterView />,
    },
    redirect: { name: names.list },
    children: [
      {
        path: "list",
        name: names.list,
        meta: {
          title: "Asbestos Projects",
          lookupGroups: ["AsbestosProjectType", "AsbestosNotificationFormType", "AsbestosProjectStatus"],
        },
        component: () => import("@/views/asbestosProjects/AsbestosProjectList.vue"),
      },
      // {
      //   path: "new",
      //   component: () => import("@/views/asbestosProjects/AsbestosProjectBase.vue"),
      //   redirect: { name: names.new },
      //   props: true,
      //   children: [
      //     {
      //       path: "",
      //       name: names.new,
      //       meta: { title: "New Asbestos Project", isNew: true },
      //       component: () => import("@/views/asbestosProjects/AsbestosProjectEdit.vue"),
      //     },
      //   ],
      // },
      {
        path: ":id(\\d+)",
        name: names.base,
        component: () => import("@/views/asbestosProjects/AsbestosProjectBase.vue"),
        redirect: { name: names.view },
        children: [
          {
            path: "view",
            name: names.view,
            meta: { title: "Asbestos Project View" },
            component: () => import("@/views/asbestosProjects/AsbestosProjectView.vue"),
          },
          // {
          //   path: "edit",
          //   name: names.edit,
          //   meta: { title: "Asbestos Project Edit", isForm: true },
          //   component: () => import("@/views/asbestosProjects/AsbestosProjectEdit.vue"),
          // },
          {
            path: "inspections",
            name: names.asbestosInspectionsChildList,
            meta: { title: "Inspections", lookupGroups: ["InspectionStatus", "InspectionType"] },
            component: () => import("@/views/asbestosProjects/AsbestosInspectionChildList.vue"),
          },
          {
            path: "notifications",
            name: names.asbestosNotificationsChildList,
            meta: {
              title: "Notifications",
            },
            component: () => import("@/views/asbestosProjects/AsbestosNotificationChildList.vue"),
          },
          {
            path: "activity",
            name: names.audit,
            meta: { title: "Asbestos Project Audit Activity" },
            component: {
              render: () => <EntityAudit entityType="AsbestosProject" />,
            },
          },
        ],
      },
    ],
  },
];
export default asbestosProjectRoutes;
